import React, { useRef, useState, useEffect, useCallback, Fragment } from "react";
import { LandingPageContainer, Icon, Text, Arrow } from "./landing-page-style";
import { useTransition } from "react-spring";
import { useMediaQuery } from "../../hooks";
import { MOBILE_WIDTH } from "../../constants";

export const LandingPage = () => {
  const isMobileView = useMediaQuery(MOBILE_WIDTH);

  const ref = useRef([]);

  const [items, set] = useState([]);

  const subtitleTransition = useTransition(items, null, {
    from: {
      opacity: 0,
    },
    enter: [{ opacity: 1 }],
  });
  const reset = useCallback(() => {
    ref.current.map(clearTimeout);
    ref.current = [];
    set([]);
    if (isMobileView) {
      ref.current.push(setTimeout(() => set(["Records by people who care", "about independent music"]), 500));
    } else {
      ref.current.push(setTimeout(() => set(["Records by people who care about", "independent music"]), 500));
    }
  }, [isMobileView]);

  const logoTransition = useTransition(null, null, {
    from: {
      opacity: 0,
      height: 0,
      innerHeight: 0,
      transform: "perspective(600px) rotateX(0deg)",
    },
    enter: (item) => async (next, cancel) => {
      await new Promise((resolve) => setTimeout(resolve, 2500));
      await next({
        opacity: 1,
        height: isMobileView ? 150 : 300,
        innerHeight: isMobileView ? 150 : 300,
      });
    },
  });

  const arrowTransition = useTransition(null, null, {
    from: {
      opacity: 0,
      transform: "translate(0, 100%)",
    },
    enter: (item) => async (next, cancel) => {
      await new Promise((resolve) => setTimeout(resolve, 3500));
      await next({ opacity: 1, transform: "translate(0,0)" });
    },
  });

  useEffect(() => void reset(), [reset]);

  return (
    <Fragment>
      <LandingPageContainer>
        {logoTransition.map(({ item, key, props: { innerHeight, ...rest } }) => (
          <Icon
            style={{ overflow: "hidden", height: innerHeight, position: "relative", zIndex: 0 }}
            src="/assets/organic-audio-icon.svg"
            key={item}
          />
        ))}
        <div>
          {subtitleTransition.map(({ item, props: { innerHeight, ...rest }, key }) => (
            <Text style={rest} key={item}>
              {item}
            </Text>
          ))}
        </div>
        {arrowTransition.map(({ item, props, key }) => (
          <Arrow style={{ ...props }} src="/assets/down-arrow.svg" key={item} />
        ))}
      </LandingPageContainer>
    </Fragment>
  );
};
